import { useLocation } from 'react-router-dom';
// import { utcToZonedTime, format } from 'date-fns-tz'
// import { es } from 'date-fns/locale'

export const TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export function getToken(state) {
  if (state) {
    return state.auth ? state.auth.token : null;
  }
  return null;
}

export function getAuthHeaders(state) {
  const token = getToken(state);

  if (token) {
    return {
      Authorization: `Bearer ${token}`,
    };
  }
  return {};
}

export function createAction(type, keys = []) {
  const fn = function () {
    const args = keys.reduce((acc, item, idx) => {
      acc[item] = keys[idx];
      return acc;
    }, {});

    return { type, ...args };
  };

  return [type, fn];
}

export function useQuery() {
  const query = new URLSearchParams(useLocation().search);

  const items = {};

  const entries = query.entries().map;

  entries.map(([entryZero, entryOne]) => {
    items[entryZero] = entryOne;

    return '';
  });

  return items;
}

export function toQueryString(query) {
  return Object.keys(query)
    .reduce((acc, key) => {
      if (query[key]) {
        acc.push(`${key}=${query[key]}`);
      }

      return acc;
    }, [])
    .join('&');
}

export function getTokenParams() {
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);

  return params.get('token');
}

export const IMAGE_TYPES = {
  'image/jpg': 'jpg',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
};

export const FILE_EXTENSIONS_MAPPING = {
  'application/vnd.ms-excel': 'xls',
  'application/msexcel': 'xlsx',
  'application/x-msexcel': 'jxlsx',
  'application/x-ms-excel': 'xlsx',
  'application/x-excel': 'xlsx',
  'application/x-dos_ms_excel': 'xlsx',
  'application/xls': 'xls',
  'application/x-xls': 'xlsx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/msword': 'doc',
  'application/pdf': 'pdf',
  'application/zip': 'zip',
  'application/x-zip-compressed': 'zip',
  'multipart/x-zip': 'zip',
  'text/plain': 'txt',
  ...IMAGE_TYPES,
};
